import { Container, Row, Col } from "react-bootstrap";
import { MailchimpForm } from "./MailchimpForm";
import logo from "../assets/img/ai logo.png";
import navIcon1 from '../assets/img/linkedin-icon.svg';
import navIcon2 from '../assets/img/github-icon.svg';
import navIcon3 from '../assets/img/twitter-icon.svg';

export const Footer = () => {
  return (
    <footer className="footer">
      <Container>
        <Row className="align-items-center">
          <MailchimpForm />
          <Col size={12} sm={6}>
            <img src={logo} alt="Logo" />
          </Col>
          {/* increase padding to 12, 6 */}
          <Col size={12} sm={6} className="text-center text-sm-end">
            <div className="social-icon">
                <a href="https://www.linkedin.com/in/lokesh-sai-kurmapu/" target="_blank"><img src={navIcon1} alt="Connect on LinkedIn" /></a>
                <a href="https://twitter.com/Kurmapu_loki" target="_blank"><img src={navIcon3} alt="Dm on twitter" /></a>
                <a href="https://github.com/k-loki" target="_blank"><img src={navIcon2} alt="connect on github" /></a>
            </div>
            <p>Credits to <a href="https://www.youtube.com/@webdecoded" target='_blank'> judygab</a> for providing this template.</p>
          </Col>
        </Row>
      </Container>
    </footer>
  )
}
